<template>
  <b-form-group
    label="Arama"
    label-for="keyword"
  >
    <b-input-group>
      <b-form-input
        id="keyword"
        v-model="filterParams.keyword"
        placeholder="Açıklama içerisinde arama"
        @keydown.enter="getDataList"
      />
      <b-input-group-append>
        <b-button
          variant="primary"
          @click="getDataList"
        >
          <FeatherIcon icon="SearchIcon" />
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>
<script>
import {
  BButton, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'

export default {
  name: 'SearchBox',
  components: {
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BFormGroup,
    BFormInput,
  },
  props: {
    getDataList: {
      type: Function,
      required: true,
    },
  },
  computed: {
    filterParams() {
      return this.$store.getters['accountActivities/filterParams']
    },
  },
}
</script>
